const runtime = process.env.NEXT_RUNTIME || process.env.runtime;

// The embed widget is bundled by Vite into a plain browser IIFE that has NO
// `require`, so the require() calls below would throw "require is not defined"
// at module load and take down the entire bundle (no widget renders). Webpack
// (the Next app, incl. its client bundles) and Node both DO provide `require`,
// so only fall back to a console-backed shim when `require` is truly absent —
// this leaves the Next app's behaviour completely unchanged.
const hasRequire = typeof require !== 'undefined';

function createBrowserLogger() {
  const noop = () => undefined;
  return {
    ServerLogger: class {},
    // Any method access (info/warn/error/debug/…) resolves to a no-op so the
    // embed never crashes regardless of which logger method a shared module calls.
    serverLogger: new Proxy({}, { get: () => noop }),
    getServerLogs: () => [],
    clearServerLogs: noop,
    getLogStats: () => ({}),
  };
}

// Dynamically choose the logger implementation based on runtime
export const { ServerLogger, serverLogger, getServerLogs, clearServerLogs, getLogStats } = !hasRequire
  ? createBrowserLogger()
  : runtime === 'edge'
  ? // eslint-disable-next-line @typescript-eslint/no-require-imports
    require('./server-logger.edge')
  : // eslint-disable-next-line @typescript-eslint/no-require-imports
    require('./server-logger.node');
